import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import packageJson from '../../../../../../package.json';

export interface ClientInfo {
    version: string;
    id?: string;
    platform: string;
}

export const getClientInfo = async (): Promise<ClientInfo> => {
    const platform = Capacitor.getPlatform();
    if (Capacitor.isNativePlatform()) {
        const { version, id } = await App.getInfo();
        return { version, id, platform };
    }
    return { version: packageJson.version, platform };
};